import script from "./FooterSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./FooterSection.vue?vue&type=script&setup=true&lang=ts"

import "./FooterSection.vue?vue&type=style&index=0&id=1bcbd91a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bcbd91a"]])

export default __exports__